import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaYoutube } from 'react-icons/fa';
import logo from '../Assets/SR_logo.png';

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="container">
                <div className="row g-4">
                    <div className="col-lg-4">
                        <div className="brand-lockup footer-brand">
                            <img src={logo} alt="" height={48} />
                            <span>
                                <strong>Sona Alusys</strong>
                                <small>Industries</small>
                            </span>
                        </div>
                        <p>
                            Creators of modern spaces in aluminium, glass, and UPVC. We design, fabricate, and install facades that last longer and finish cleaner.
                        </p>
                    </div>
                    <div className="col-6 col-lg-2">
                        <h3>Navigate</h3>
                        <Link to="/">Home</Link>
                        <Link to="/about">About</Link>
                        <Link to="/services">Services</Link>
                        <Link to="/projects">Projects</Link>
                        <Link to="/gallery">Gallery</Link>
                        <Link to="/clients">Clients</Link>
                        <Link to="/contact">Contact</Link>
                    </div>
                    <div className="col-6 col-lg-3">
                        <h3>Services</h3>
                        <Link to="/services">Glazing</Link>
                        <Link to="/services">Cladding</Link>
                        <Link to="/services">Doors &amp; Windows</Link>
                        <Link to="/services">Railing</Link>
                        <Link to="/services">Canopies &amp; Skylights</Link>
                    </div>
                    <div className="col-lg-3">
                        <h3>Contact</h3>
                        <p>
                            Khasra No. 212, Vill. Piplehda, Dasna, Bhoorgarhi Road, Tehsil-Dhaulana, District Hapur, Uttar Pradesh - 201015
                        </p>
                        <a href="tel:+919555808671">+91-9555808671</a>
                        <a href="tel:+919211515758">+91-9211515758</a>
                        <a href="mailto:info@sonaalusys.com">info@sonaalusys.com</a>
                        <div className="footer-social">
                            <button type="button" aria-label="Instagram" onClick={() => window.open('https://www.instagram.com/sonaalusys/', '_blank', 'noopener,noreferrer')}>
                                <FaInstagram />
                            </button>
                            <button type="button" aria-label="YouTube" onClick={() => window.open('https://www.youtube.com/@SonaAlusysIndustries', '_blank', 'noopener,noreferrer')}>
                                <FaYoutube />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="footer-bar">Copyright {new Date().getFullYear()} Sona Alusys Industries. All rights reserved.</div>
            </div>
        </footer>
    );
};

export default Footer;
